import { makeStyles } from "components/providers/makeStyles";

import { T } from "../../util/t";

const useStyles = makeStyles(theme => ({
    break: {
        margin: theme.spacing(1, 0),
        padding: theme.spacing(0.5, 0),
        textAlign: "center",
        background: "repeating-linear-gradient(45deg, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5) 5px, rgba(150, 150, 150, 0.5) 5px, rgba(150, 150, 150, 0.5) 6px)",
        textTransform: "uppercase",
        fontWeight: 700,
        fontSize: theme.typography.pxToRem(12),
        lineHeight: theme.typography.pxToRem(12)
    }
}));
export const Break = () => {
    const classes = useStyles();
    return (
        <div className={classes.break}>
            <T>Break</T>
        </div>
    );
};
